import { GetMemberProgramStartDatesV2Query } from '@src/graphqlTypes/catalogServiceTypes';

export interface ProgramUuidsByStartDate {
	next_30_days: string[];
	next_60_days: string[];
	next_90_days: string[];
}

/**
 * Categorizes programs by their start dates into time buckets
 * @param programs - Array of programs from GetMemberProgramStartDatesV2Query
 * @returns Object with program UUIDs categorized by start date ranges
 */
export const categorizeProgramsByStartDate = (
	programs: GetMemberProgramStartDatesV2Query['memberPrograms'] = []
): ProgramUuidsByStartDate => {
	const now = new Date();
	const thirtyDaysFromNow = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
	const sixtyDaysFromNow = new Date(now.getTime() + 60 * 24 * 60 * 60 * 1000);
	const ninetyDaysFromNow = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000);

	const categorizedPrograms: ProgramUuidsByStartDate = {
		next_30_days: [],
		next_60_days: [],
		next_90_days: [],
	};

	programs.forEach(program => {
		if (!program?.uuid) return;

		const startDate = program.nextDate?.startDate;

		if (!startDate) {
			return;
		}

		const programStartDate = new Date(startDate);

		if (programStartDate > now) {
			if (programStartDate <= thirtyDaysFromNow) {
				categorizedPrograms.next_30_days.push(program.uuid);
			}
			if (programStartDate <= sixtyDaysFromNow) {
				categorizedPrograms.next_60_days.push(program.uuid);
			}
			if (programStartDate <= ninetyDaysFromNow) {
				categorizedPrograms.next_90_days.push(program.uuid);
			}
		}
	});

	return categorizedPrograms;
};
